import { useNavigate } from "react-router-dom";
import { capitalizar } from "../hooks/elapsed";

export const ItemTabComponent = ({
  p_seleccion,
  seccion,
  nombre,
  icono,
  titulo,
}) => {
  const navigate = useNavigate();
  const IrA = (ruta: string) => {
    navigate(`/home/ver/${ruta}`);
  };
  return (
    <div
      className={
        p_seleccion === seccion
          ? "flex cursor-pointer flex-col rounded-xl bg-primary px-1 py-2 text-center text-white "
          : "border-red flex cursor-pointer  flex-col content-center justify-items-center rounded-xl border-2 bg-white px-1 py-2  text-center  hover:bg-primary hover:text-white"
      }
      onClick={() => IrA(nombre)}
    >
      <span className="mx-auto">{icono}</span>
      <span className="text-sm">{titulo}</span>
    </div>
  );
};
